import { useTheme } from '@material-ui/core';
import ModalMLStyled from './ModalMLStyled';
import LoadingML from '@/components/LoadingML';
// import { useForm } from 'react-hook-form';
import { Card, CardContent, IconButton } from '@material-ui/core';
// 关闭modal图标
import SvgIconML from '@/components/SvgIconML/SvgIconML';

const ModalML = (props) => {
  const theme = useTheme();
  // const {
  //   // setValue,
  //   // errors,
  //   // getValues,
  //   // register,
  // } = useForm({});
  return (
    <ModalMLStyled
      theme={theme}
      isHasBcg={props.isHasBcg}
      // style={modalStyle}
      // className={classes.paper}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={props.open}
      onClose={props.onClose}
      disableEscapeKeyDown={true}
    >
      <div style={{ height: '100%', width: '100%' }}>
        <LoadingML loading={props.loading} className="modal-content">
          <Card className="add-or-edt">
            <div className="modal-title">
              <p style={{ width: '100%' }}>{props.title}</p>
              {!props?.isHasIcon && (
                <span className="close">
                  <IconButton
                    // className={!canEdit && 'no-drop'}
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    color="inherit"
                    onClick={props.onClose}
                  >
                    {/* <SvgIconML
                    name="edit"
                    size={24}
                    fill={
                      canEdit
                        ? theme.palette.primary.main
                        : theme.palette.secondary.disabled
                    }
                    className={canEdit && 'canClick'}
                  /> */}
                    {}
                    <SvgIconML
                      fill={props.isHasBcg ? '#fff' : '#000'}
                      size={20}
                      name={'modalClose'}
                    ></SvgIconML>
                  </IconButton>
                </span>
              )}
            </div>
            <CardContent className="cardContent">{props.children}</CardContent>
          </Card>
        </LoadingML>
      </div>
    </ModalMLStyled>
  );
};
export default ModalML;
